export default "__VITE_ASSET__f284301e__"